'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _CommunityVideoPlayer = require('../../CommunityVideoPlayer');

var _CommunityVideoPlayer2 = _interopRequireDefault(_CommunityVideoPlayer);

var _InactivityDimmer = require('../../shared/InactivityDimmer');

var _InactivityDimmer2 = _interopRequireDefault(_InactivityDimmer);

var _theatreUtil = require('../utils/theatre-util');

var _theatreUtil2 = _interopRequireDefault(_theatreUtil);

var _propTypes = require('../../../shared/prop-types');

var _adTrackingUtil = require('../../../utils/ad-tracking-util');

var _adTrackingUtil2 = _interopRequireDefault(_adTrackingUtil);

var _communityContentPlayers = require('../../../shared/logging/community-content-players');

var _communityContentPlayers2 = _interopRequireDefault(_communityContentPlayers);

require('./_theatre-player.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheatrePlayer = function (_PureComponent) {
  _inherits(TheatrePlayer, _PureComponent);

  function TheatrePlayer() {
    _classCallCheck(this, TheatrePlayer);

    return _possibleConstructorReturn(this, (TheatrePlayer.__proto__ || Object.getPrototypeOf(TheatrePlayer)).apply(this, arguments));
  }

  _createClass(TheatrePlayer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !this.props.recommendations || !this.props.recommendations.length || this.props.recommendations !== nextProps.recommendations;
    }
  }, {
    key: 'getLogData',
    value: function getLogData() {
      var logData = _extends({}, this.props.logData, {
        adTrackingId: _adTrackingUtil2.default.getAdTrackingIdAndSetCookie(),
        player: _communityContentPlayers2.default.Immersive
      });
      return logData;
    }
  }, {
    key: 'getPlayables',
    value: function getPlayables() {
      return this.props.recommendations && this.props.recommendations.map(_theatreUtil2.default.recommendationToPlayable);
    }
  }, {
    key: 'getItemPreviews',
    value: function getItemPreviews() {
      var recommendations = this.props.recommendations;

      var itemPreviews = null;
      if (recommendations) {
        itemPreviews = recommendations.map(function (recommendation) {
          return {
            ownerName: (recommendation.ownerDetails || {}).name,
            title: recommendation.title,
            thumbnail: recommendation.thumbnailUrl
          };
        });
      }
      return itemPreviews;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          adTag = _props.adTag,
          playerId = _props.playerId,
          recommendations = _props.recommendations;


      if ((0, _isEmpty2.default)(recommendations)) return null;

      // We don't want to pass the ad tag into the immserive player because
      // it would trigger another ad request when the player initialized. However,
      // we do want to keep the player tech the same to ensure a consistent experience.
      var playerTech = !!adTag ? 'jw' : 'theo';

      return _react2.default.createElement(
        'div',
        { className: 'theatre-player-container' },
        _react2.default.createElement(
          _InactivityDimmer2.default,
          null,
          _react2.default.createElement(_CommunityVideoPlayer2.default, {
            autoplay: true,
            className: 'theatre-player-main-content',
            itemPreviews: this.getItemPreviews(),
            logData: this.getLogData(),
            muted: false,
            trackInViewVideo: true,
            playerId: playerId,
            playables: this.getPlayables(),
            playerTech: playerTech
          })
        )
      );
    }
  }]);

  return TheatrePlayer;
}(_react.PureComponent);

TheatrePlayer.propTypes = {
  adTag: _propTypes.adTagShape,
  feedContentId: _react.PropTypes.string.isRequired,
  logData: _react.PropTypes.shape({
    container: _react.PropTypes.number.isRequired,
    isAutoAdvance: _react.PropTypes.isRequired,
    player: _react.PropTypes.number.isRequired
  }).isRequired,
  playerId: _react.PropTypes.string.isRequired,
  recommendations: _react.PropTypes.array,
  selectedRecommendation: _react.PropTypes.object
};
TheatrePlayer.contextTypes = {
  store: _propTypes.StoreShape
};
exports.default = TheatrePlayer;